import React, { PureComponent } from 'react';
import CommonList from '../../../components/CommonLists/list';
import { message } from 'antd';
import services from '../../../services/api';
import Modal from '../../../components/Modal/index';
const columns = [
  {
    title: '用户名',
    dataIndex: 'username',
    key: 'username'
  },
  {
    title: '权限',
    dataIndex: 'right_level',
    key: 'right_level',
    width: '30%'
  },
  {
    title: '备注',
    dataIndex: 'des',
    key: 'des',
    width: '12%'
  }
];

@CommonList(columns, 'usersConfig')
class UserList extends PureComponent {
  constructor() {
    super();
  }
  componentDidMount() {}
  delete(record) {
    Modal.open({
      title: '提示',
      width: '300px',
      content: '确定要删除?',
      isOkBtn: true,
      isCancelBtn: true,
      ok: () => {
        services.usersConfig
          .delete({ username: record.username })
          .then(data => {
            if (data.code === 0) {
              message.success(data.msg);
              this.props.queryList();
              Modal.close();
            } else {
              message.error(data.msg);
            }
          });
      },
      cancel: () => {
        Modal.close();
      }
    });
  }
  render() {
    return <div />;
  }
}

export default UserList;
